import { render, staticRenderFns } from "./supGoodsInfo.vue?vue&type=template&id=639ff5ab&scoped=true&"
import script from "./supGoodsInfo.vue?vue&type=script&lang=js&"
export * from "./supGoodsInfo.vue?vue&type=script&lang=js&"
import style0 from "./supGoodsInfo.vue?vue&type=style&index=0&id=639ff5ab&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639ff5ab",
  null
  
)

export default component.exports